import { LaboursAndPartsTab } from './labours-and-parts/components';
import { RepairOrderQuotesTab } from './repair-order-quotes';
import { ReportTab } from './report';
import styles from './styles.module.scss';
import { useVhcRecord } from './useVhcRecord';
import { useVhcRecordPage } from './useVhcRecordPage';
import { VhcTab } from './vhc';
import { VideoTab } from './video/components/index';
import cn from 'classnames';
import clsx from 'clsx';
import { NewContactWrapper } from 'components/new-contact/new-contact-wrapper';
import { InlineSvg } from 'components/svg';
import { useIsInIframe } from 'features/notifications/hooks/use-is-in-Iframe';
import { useNewContactWithWorkshop } from 'features/vhc/hooks/use-new-contact-with-workshop';
import { EditMileageModal } from 'features/vhc/modals/edit-mileage/modal';
import { VhcRecordModal } from 'features/vhc/modals/record';
import { PreviewImageComponent } from 'features/vhc/shared/preview-image/preview-image-component';
import { PreviewFileType, PreviewImageContext } from 'features/vhc/shared/preview-image/preview-image-context';
import { useState } from 'react';
import { Card, Nav, Tab } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { useParams } from 'react-router-dom';
import { formatDate } from 'utils/formats';

export const VhcRecordPage = () => {
  return (
    <NewContactWrapper>
      <VhcRecordComponent />
    </NewContactWrapper>
  );
};
const VhcRecordComponent = () => {
  const isInIframe = useIsInIframe();
  const [showMileageModal, setShowMileageModal] = useState<boolean>();

  const { id } = useParams();
  const { activeTab, handleTabSelect, handleClose } = useVhcRecordPage();
  const [previewImages, setPreviewImage] = useState<{ urls?: PreviewFileType[]; openIndex?: number }>();

  const {
    generalData,
    isLoading,
    refetch,
    refetchLabours,
    refetchParts,
    laboursData,
    partsData,
    vhcData,
    isLoadingLabours,
    isLoadingParts
  } = useVhcRecord({ id: id || '' });

  const { refetchWorkshop, isFetchingWorkshop } = useNewContactWithWorkshop(
    { id: generalData?.id, soHeaderId: generalData?.soHeaderId },
    false
  );

  const handleClickCustomer = () => {
    if (isFetchingWorkshop || !generalData?.soHeaderId) return;
    refetchWorkshop();
  };

  const { wipNo, regNo, dateCreate, vin, mileage } = generalData || {};

  if (isLoading)
    return (
      <Card className="shadow-sm ">
        <Card.Header className="relative py-0 px-0 border-0 ">
          <div className="d-flex align-items-center justify-content-between pt-7 px-3 w-100 pe-3">
            <div className="d-flex align-items-center flex-wrap gap-7 px-10 fs-4 fw-bold ">
              <span className="fs-2 text-gray-700">VHC Record</span>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Skeleton height={'300px'} style={{ marginBottom: '10px', borderRadius: 6 }} />
        </Card.Body>
      </Card>
    );

  return (
    <>
      <Card className="shadow-sm ">
        <Card.Header className="relative py-0 px-0 border-0 ">
          <div className="d-flex align-items-center justify-content-between pt-7 px-3 w-100 pe-3">
            <div className="d-flex align-items-center flex-wrap gap-7 px-10 fs-4 fw-bold ">
              <span className="fs-2 text-gray-700">VHC Record</span>
              <div className="d-flex align-items-center gap-2">
                {wipNo && <span className="badge bg-success text-white uppercase p-3">WIP {wipNo}</span>}
                {regNo && <span className="badge bg-warning text-black uppercase p-3">{regNo}</span>}
              </div>
              {vin && (
                <div className="d-flex align-items-center gap-2">
                  <span className="text-gray-500">VIN</span>
                  <span className="text-black">{vin}</span>
                </div>
              )}
              {mileage && (
                <div className="d-flex align-items-center gap-2">
                  <span className="text-gray-500">Mileage</span>
                  <span className="text-black">{mileage}</span>
                  <button
                    disabled={generalData?.soHeaderClosed ?? false}
                    type="button"
                    onClick={() => setShowMileageModal(true)}
                    className={styles.mileageBtn}
                  >
                    <InlineSvg path="/media/icons/custom/pencil.svg" />
                  </button>
                </div>
              )}

              {dateCreate && (
                <div className="d-flex align-items-center gap-2">
                  <span className="text-gray-400">{formatDate(dateCreate, 'D MMM YYYY')}</span>
                </div>
              )}
            </div>

            {!isInIframe && (
              <div onClick={handleClose} style={{ right: 25, top: 25 }} className="position-absolute cursor-pointer">
                <InlineSvg path="/media/icons/custom/cross-circle.svg" className="svg-icon-1 me-1" />
              </div>
            )}
          </div>
          <div
            style={{ borderBottomWidth: 1, borderBottomStyle: 'solid', borderBottomColor: '#E6E6E6', width: '100%' }}
            className="mx-10 px-4 mb-3 mt-2 pb-5"
          >
            <div className={`d-flex align-items-center flex-nowrap gap-2 mt-2`}>
              <div role="button" onClick={() => handleClickCustomer()}>
                <InlineSvg path="/media/icons/custom/name1.svg" />
              </div>
              <div className={`${styles.customerName}`}>{generalData?.customerName ?? '-'}</div>
              <div className={`${styles.customerTypeName}`}>{generalData?.customerTypeName ?? '-'}</div>
            </div>
          </div>
        </Card.Header>
        <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
          <Nav variant="tabs" className="border-0 px-10">
            <Nav.Item>
              <Nav.Link
                eventKey="vhc"
                className={cn(
                  'border-0',
                  activeTab === 'vhc' ? 'text-secondary border-bottom border-1 border-secondary' : 'text-gray-500'
                )}
              >
                VHC Record
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="labours"
                className={cn(
                  'border-0',
                  activeTab === 'labours' ? 'text-secondary border-bottom border-1 border-secondary' : 'text-gray-500'
                )}
              >
                Labours & Parts
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="RepairOrderQuotes"
                className={cn(
                  'border-0',
                  activeTab === 'RepairOrderQuotes'
                    ? 'text-secondary border-bottom border-1 border-secondary'
                    : 'text-gray-500'
                )}
              >
                Repair Order Quotes
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="video"
                className={cn(
                  'border-0',
                  activeTab === 'video' ? 'text-secondary border-bottom border-1 border-secondary' : 'text-gray-500'
                )}
              >
                Video
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="report"
                className={cn(
                  'border-0',
                  activeTab === 'report' ? 'text-secondary border-bottom border-1 border-secondary' : 'text-gray-500'
                )}
              >
                Report
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Tab.Container>

        <Card.Body>
          <Tab.Content>
            <Tab.Pane eventKey="vhc" active={activeTab === 'vhc'}>
              {activeTab === 'vhc' && vhcData && (
                <VhcTab
                  id={Number(id)}
                  wipNo={vhcData.generalData.wipNo ?? ''}
                  regNo={vhcData.generalData.regNo ?? ''}
                  mileage={vhcData.generalData.mileage ?? 0}
                  vin={vhcData.generalData.vin ?? ''}
                  carDescription={vhcData.generalData.carDescription ?? ''}
                  varclass={vhcData.generalData.varclass!}
                  customerName={vhcData.generalData.customerName ?? ''}
                  refetch={refetch}
                  dateComplete={vhcData.generalData.dateComplete}
                  userComplete={vhcData.generalData.userComplete}
                />
              )}
            </Tab.Pane>

            <Tab.Pane eventKey="labours" active={activeTab === 'labours'}>
              {isLoadingLabours && isLoadingParts && (
                <Skeleton height={'100px'} style={{ marginBottom: '3px', borderRadius: 6 }} />
              )}
              {vhcData && (
                <LaboursAndPartsTab
                  onLookUpClick={() => {
                    refetchLabours();
                    refetchParts();
                  }}
                  labours={laboursData?.items}
                  dateCreatePartRequest={vhcData.generalData.dateCreatePartRequest}
                  userCreatePartRequest={vhcData.generalData.userCreatePartRequest}
                  partRequestStatus={vhcData.generalData.partRequestStatus}
                  parts={partsData?.items}
                  recordId={Number(id)}
                  refetch={refetch}
                  isRepairOrdersCreated={vhcData.generalData.isRepairOrderQuotesCreated ?? false}
                  dateCreateRepairOrderQuote={vhcData.generalData.dateCreateRepairOrderQuote}
                  userCreateRepairOrderQuote={vhcData.generalData.userCreateRepairOrderQuote}
                  isComplete={Boolean(vhcData?.generalData.dateComplete) && Boolean(vhcData?.generalData.userComplete)}
                />
              )}
            </Tab.Pane>

            <Tab.Pane eventKey="video" active={activeTab === 'video'}>
              {activeTab === 'video' && vhcData && <VideoTab {...vhcData.generalData} />}
            </Tab.Pane>

            <Tab.Pane eventKey="report" active={activeTab === 'report'}>
              {vhcData && <ReportTab />}
            </Tab.Pane>
            <Tab.Pane eventKey="RepairOrderQuotes" active={activeTab === 'RepairOrderQuotes'}>
              <div className={clsx(activeTab === 'RepairOrderQuotes' ? 'd-block' : 'd-none')}>
                <RepairOrderQuotesTab
                  soHeaderId={vhcData?.generalData.soHeaderId ?? undefined}
                  regNo={vhcData?.generalData.regNo ?? undefined}
                  checkResult={vhcData?.generalData.checkResult ?? []}
                  dateCompleted={vhcData?.generalData.dateComplete}
                  dateSentAuthorizationRequiredEmail={vhcData?.generalData.dateSentAuthorizationRequiredEmail}
                  userSentAuthorizationRequiredEmail={vhcData?.generalData.userSentAuthorizationRequiredEmail}
                  dateSentAuthorizationRequiredSms={vhcData?.generalData.dateSentAuthorizationRequiredSms}
                  userSentAuthorizationRequiredSms={vhcData?.generalData.userSentAuthorizationRequiredSms}
                  refetchVhcRecord={refetch}
                  branchId={vhcData?.generalData?.branch}
                />
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Card.Body>
      </Card>
      <PreviewImageContext.Provider
        value={{
          previewImages: previewImages?.urls,
          openIndex: previewImages?.openIndex,
          showPreviewImage: (urls, openIndex) => setPreviewImage({ urls, openIndex })
        }}
      >
        <PreviewImageComponent />
        <VhcRecordModal />
      </PreviewImageContext.Provider>
      {showMileageModal && vhcData?.generalData.wipNo && vhcData?.generalData.regNo && (
        <EditMileageModal
          id={Number(id)}
          wipNo={vhcData?.generalData.wipNo}
          regNo={vhcData?.generalData.regNo}
          carDescription={vhcData?.generalData.carDescription ?? ''}
          varclass={vhcData?.generalData.varclass!}
          vin={vhcData?.generalData.vin!}
          warranty={undefined}
          customerName={vhcData?.generalData.customerName ?? ''}
          mileage={vhcData?.generalData.mileage}
          soHeaderId={vhcData?.generalData.soHeaderId}
          branchId={vhcData?.generalData.branch ?? undefined}
          cdkVehicleId={vhcData?.generalData.cdkVehicleId ?? undefined}
          onClose={(isReload) => {
            if (isReload) refetch();
            setShowMileageModal(false);
          }}
        />
      )}
    </>
  );
};
